import { render, staticRenderFns } from "./TransferUsers.vue?vue&type=template&id=9265da9e&"
import script from "./TransferUsers.vue?vue&type=script&lang=js&"
export * from "./TransferUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports